import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {UserService} from '../services/user.service';
import {User} from '../models/user.model';

@Injectable()
export class PermissionGuard implements CanActivate, CanLoad {
  constructor(private user: UserService, private router: Router) {
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return undefined;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const permissions = route.data['permissions'].map(elem => {
      return elem.replace('__', '_' + route.params.variant + '_');
    });

    return this.user.getCurrentUser().map((user: User) => {
      permissions.forEach(permission => {
        if (!user.hasPermission(permission)) {
          console.log('No permission!');
          this.router.navigate(['/404']);
          return false;
        }
      });

      return true;
    });
  }
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/guards/permission.guard.ts